export function getFormattedUtmParams(): string {
  const storedParams = sessionStorage.getItem("utmParams");
  const urlStringParams = window.location.search;

  if (!storedParams) {
    return urlStringParams;
  }
  const utmParams = JSON.parse(storedParams);
  if (typeof utmParams !== "object" || utmParams === null) {
    return "";
  }

  const searchParams = new URLSearchParams();
  Object.entries(utmParams).forEach(([key, value]) => {
    if (value !== "") {
      const formattedKey = `${key.slice(0, 3)}_${key.slice(3)}`.toLowerCase();
      searchParams.append(formattedKey, value as string);
    }
  });
  const utmString = searchParams.toString();
  return utmString ? `?${utmString}` : "";
}
